import React, { useEffect, useState } from "react";
import TopNavigation from "../../../components/TopNavigation";
import * as Assets from "../../../utils/svg_assets";
import { Base } from "../../../components/RootLayout";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import "./style.scss";

const AnnouncementListLikes = (props) => {
  const params = useParams();
  const { getListLikes } = props;
  const [dataLikes, setDataLikes] = useState([]);

  const getDataLikes = async () => {
    const { status, data } = await getListLikes(params?.announcementId);
    if (status == 200) {
      setDataLikes(data?.results);
    } else {
      setDataLikes([]);
    }
  };

  useEffect(() => {
    getDataLikes();
  }, []);

  return (
    <Base>
      <TopNavigation
        titlePage={`Like (${dataLikes?.length})`}
        toPath={-1}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <div className="detail-likes-wrapper">
        {dataLikes &&
          dataLikes.map((a, index) => (
            <div className="list" key={index}>
              <div className="image-wrapper">
                <img src={a?.creator?.image} alt="logo_image" />
              </div>
              <div className="desc-wrapper">
                <span className="name">{a?.creator?.name}</span>
              </div>
            </div>
          ))}
      </div>
    </Base>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  getListLikes: dispatch.AnnouncementSM.getListLikes,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnnouncementListLikes);
